import { createSlice } from '@reduxjs/toolkit';
import { getExportations } from './thunk';

export const initialState = {
  isLoading: false,
  exportations: [],
  meta: {},
  error: {},
  filters: [],
  isError: false,
};

const exportationsSlice = createSlice({
  name: 'Exportations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExportations.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getExportations.fulfilled, (state, action) => {
      state.isLoading = false;
      state.exportations = action.payload?.data;
      state.meta = action.payload?.meta;
    });
    builder.addCase(getExportations.rejected, (state, action) => {
      state.isError = true;
      state.error = action.payload?.error || null;
      console.log(action);
    });
  },
});

export default exportationsSlice.reducer;